import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center py-12 px-4" data-testid="payment-cancel-page">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="w-16 h-16 bg-stone-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-8 h-8 text-muted-foreground" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Betaling annulleret</h1>
          <p className="text-muted-foreground mb-6">
            Din betaling blev afbrudt. Ingen beløb er trukket.
          </p>
          <div className="flex gap-3">
            <Button variant="outline" className="flex-1" onClick={() => navigate('/')} data-testid="cancel-to-home-button">
              Forsiden
            </Button>
            <Button className="flex-1" onClick={() => navigate('/abonnement')} data-testid="cancel-back-to-pricing-button">
              Prøv igen
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
